$(document).ready(function () {
    // End of use strict

    //FADE OFF LOADER
    // $('#loader').fadeOut();

    // "use strict"; // Start of use strict

    //BLOCK FROM SAVING IMAGES
    // $("body").on("contextmenu", function (e) {
    //     return false;
    // });
    //
    $("img, picture").mousedown(function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
    });

    //CHANGE TEXT IN FILE INPUT
    $("input[type=file]").on("change", function () {
        var files = $(this)[0].files;
        var inputText = "";
        if (files.length === 1) {
            inputText = $(this)
                .val()
                .split(/(\\|\/)/g)
                .pop();
        } else if (files.length > 1) {
            inputText = "Selected " + files.length + " files";
        } else {
            inputText = "Choose file(s)";
        }

        const asd =
            '<i class="fas fa-file-upload mr-1"></i>\n' +
            "<small>" +
            inputText +
            "</small>";

        $(this).next(".custom-file-label").html(asd);
    });

    //FADE ALERT MESSAGE BLOCK
    $(".alert-fade")
        .delay(5000)
        .animate(
            {
                opacity: 0,
                height: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
            },
            "fast",
            function () {
                $(this).hide();
            }
        );

    //SCROLL TO TOP
    $(".scroll-to-top").click(function () {
        $("html, body").animate(
            {
                scrollTop: $("#page-top").offset().top - 90,
            },
            500
        );
    });

    $(".search-form").mouseover(function () {
        $(".search-form input").css({
            border: "1px solid #6ed8e9",
            "border-right": "none",
        });
        $(".search-form div button").css({
            border: "1px solid #6ed8e9",
            "border-left": "none",
        });
    });

    $(".search-form").mouseleave(function () {
        $(".search-form input ").css({
            border: "1px solid #6ed8e9",
            "border-right": "none",
        });
        $(".search-form div button").css({
            border: "1px solid #6ed8e9",
            "border-left": "none",
        });
        // $(".search-form input").attr('placeholder', 'Search for tutorials...');
    });

    //DISABLE SEARCH BUTTON AFTER FORM SUBMIT
    $(".search-form").submit(function () {
        $(".search-form-button").prop("disabled", true);
        setTimeout(function () {
            $(".search-form-button").prop("disabled", false);
        }, 3000);
    });
});

$(window).on("load", function () {
    // Get the pathname of the current URL
    var pathname = window.location.pathname;
    // Check if the pathname contains the word "checkout"
    if (!pathname.includes("/checkout")) {
        $("#status").fadeOut();
        $("#preloader").delay(150).fadeOut("slow");
    }
});

//Resize topnav on scroll
// var scrollTop = 0;
// var position = $(window).scrollTop();
//
// $(window).scroll(function () {
//
//     scrollTop = $(window).scrollTop();
//
//     if (scrollTop > position && scrollTop > 5) {
//         // console.log('scrollDown');
//         $('.topnav').addClass('scrolled-nav');
//         $('.navbar-addon').slideUp(550);
//     } else if (Math.abs(position - scrollTop) > 50) {
//         // console.log('scrollUp');
//         $('.topnav').removeClass('scrolled-nav');
//         $('.navbar-addon').slideDown(550);
//     }
//
//     if (Math.abs(position - scrollTop) > 150) {
//         position = scrollTop;
//     }
//
//     if (scrollTop <= 20) {
//         $('.topnav').removeClass('scrolled-nav');
//         $('.navbar-addon').slideDown(550);
//     }
// });

//   SEARCH FORM ACTIONS
// $(".search-form").click(function () {
//     if ($(".search-form input").attr('placeholder') == 'Search for tutorials...') {
//         $(".search-form input").attr('placeholder', '');
//     }
// });
